import React from "react";
import Header from "../../components/home/header/Header";
import ProfileCards from "../../components/profile/ProfileCards";
import Footer from "../../components/footer/Footer";

const Profile = () => {
  return (
    <>
      <Header />
      <ProfileCards />
      <Footer />
    </>
  );
};

export default Profile;
